export function createSerialQueue() {
  const tails = new Map<string, Promise<unknown>>();

  return function enqueue<T>(key: string, task: () => Promise<T>): Promise<T> {
    const tail = tails.get(key) ?? Promise.resolve();
    const result = tail.then(task, task);
    tails.set(key, result);
    return result;
  };
}
